import { ButtonHTMLAttributes, PropsWithChildren } from "react";
import Icon from "../icon/Icon";
import { LucideIcon } from "lucide-react";

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
    variant: "default" | "primary" | "warning";
    size?: "small" | "medium" | "large";
    iconLeft?: LucideIcon;
    iconRight?: LucideIcon;
};

const Button = ({
    children,
    iconLeft,
    iconRight,
    ...props
}: PropsWithChildren<ButtonProps>) => {
    const { variant = "default", size = "medium", className, ...rest } = props;

    const variantClass = {
        default: `bg-cloud border border-cloud-shade shadow 
        active:bg-cloud active:border-cloud-shade active:shadow-pressed 
        hover:bg-cloud-tint hover:border-cloud
        focus-visible:outline-none focus-visible:shadow-focus
        text-black`,
        primary: `bg-primary border border-primary-shade shadow
        active:bg-primary active:border-primary-shade active:shadow-pressedDark
        hover:bg-primary-tint
        focus-visible:outline-none focus-visible:shadow-focusAccent
        text-white`,
        warning: `bg-warning border border-warning-shade shadow
        active:bg-warning active:border-warning-shade active:shadow-pressed
        hover:bg-warning-tint
        focus-visible:outline-none focus-visible:shadow-focusAccent
        text-white`,
    };

    const sizeClass = {
        small: "px-5 py-2 font-semibold rounded-xs space-x-2",
        medium: "px-6 py-2.5 font-semibold rounded-md space-x-2",
        large: "px-9 py-4 font-extrabold rounded-lg space-x-2",
    };

    return (
        <button
            className={`
            ${props.className}  
            inline-flex items-center justify-center ${variantClass[variant]} ${sizeClass[size]}       
            disabled:opacity-30 disabled:cursor-not-allowed`}
            {...rest}
        >
            {iconLeft && (
                <span className="mr-2 flex items-center">
                    <Icon icon={iconLeft} size={20} />
                </span>
            )}
            {children}
            {iconRight && (
                <span className="ml-2 flex items-center">
                    <Icon icon={iconRight} size={20} />
                </span>
            )}
        </button>
    );
};

export default Button;